// @react
import React from 'react'
import { Route, Redirect } from 'react-router-dom'
// common
import Helper from 'utils/Helper.class'
import { RouteComponentType } from 'modules/auth/types'

const UnauthorizedRoute = (props: RouteComponentType) => {
  const { isAuth, ...routeProps } = props

  return !isAuth ? (
    <Route {...routeProps} />
  ) : (
    <Redirect
      to={{ pathname: Helper.getPathFromRouteKey('MYATD_DASHBOARD') }}
    />
  )
}

export default UnauthorizedRoute
